module.exports = __webpack_public_path__ + "static/media/itunes_search.2d4a7aa7.png";